import CategoryPage from './categoryPage'

export default CategoryPage
